import React from "react"
import CheckoutForm from "../components/CheckoutForm"

const Checkout = () => {
  return (
    <>
      <CheckoutForm />
    </>
  )
}

export default Checkout
